import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('common/system', ['system']),
    nodes() {
      return this.$store.getters['overview/system/get'];
    },
  },
};
